module.exports = __webpack_public_path__ + "static/media/GalleryMain8.aba3f006.jpg";